import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { setMode, setOptions } from '../REDUX/actions';
import { goToPage } from '../../HOME/REDUX/actions';
import { SIDES, CORNERS, OPTIONS_KEY } from '../const';
import { SIZE_PAGE } from '../../HOME/const';
import BackButton from '../COMPONENTS/BackButton';
import CornersIcon from '../ASSETS/Corners.png';
import SidesIcon from '../ASSETS/Sides.png';
import { Background } from '../COMPONENTS/Background';
import Logo from '../ASSETS/TurboTilesLogo.png';
import { windowSize, dbget } from '../../HOME/utils';
import { getAppInfo } from '../../HOME/info';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import * as f from '../logic';
import _ from 'lodash';
import BmgButton from '../../HOME/COMPONENTS/BmgButton';

class StartPage extends Component {
  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    dbget(OPTIONS_KEY, options => this.props.setOptions(options));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  handleMode = mode => {
    this.props.setMode(mode);
    this.props.goToPage(SIZE_PAGE);
  };

  render() {
    const { x, y } = windowSize();
    const width = Math.min(x, y) / 7;

    return (
      <div className="page-root">
        <div className="ms-logo-title">
          <img src={Logo} width={width} alt="Turbo Tiles logo" />
          {f.blurText(getAppInfo(this.props.app).name, 8, 'ms-title')}
        </div>
        <div className="tt-page" style={{ backgroundImage: Background }}>
          {_.map([CORNERS, SIDES], mode => (
            <div key={mode} className="app-option option" onClick={() => this.handleMode(mode)} style={{ margin: '-5px', width: '265px' }}>
              <img src={mode === CORNERS ? CornersIcon : SidesIcon} alt={mode} />
              <span className="tt-option-text">{f.blurText(`PLAY ${mode}`, 4, null, { gridArea: '1/2' })}</span>
            </div>
          ))}
          <BmgButton />
          <BackButton />
          <HomeButton />
        </div>
      </div>
    );
  }
}

function mapStateToProps({ tt, common }) {
  return { ...tt, ...common };
}

export default connect(
  mapStateToProps,
  { setMode, goToPage, setOptions }
)(StartPage);
